import React, { useEffect, useCallback, useState, useRef, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { RiQuestionnaireFill } from "react-icons/ri";
import { FaDownload } from "react-icons/fa";
import plusIcon from '../../../assets/images/plus.svg';
//Style
import styles from './QuestionsList.module.scss';

//golbal context
import { useGlobalContext } from '../../../context/GlobalContext';
import { getQuestionListsAction, postQuestionsFilteredAction } from '../../../actions/questionsActions';
import { getNotifsAction } from '../../../actions/authActions';

//Components
import SortButton from '../../../components/lib/SortButton/SortButton';
import QuestionRow from '../../../components/partials/QuestionRow/QuestionRow';
import Modale from '../../../components/lib/Modale/Modale';
import Loader from '../../../components/lib/Loader/Loader';
import ExportAnswersModale from '../../AnswersType/AnswersTypeList/ExportAnswersModale/ExportAnswersModale';
import { GET_ANSWER, GET_QUESTION, SET_FILTERS, SET_SCROLL_Y } from '../../../actions/types';
import { TOOL_ID } from '../../../actions';
import { IoSearch } from 'react-icons/io5';
import FiltersToggle from '../../../components/partials/FiltersToggle';
import FiltersMobilePanel from '../../../components/partials/FiltersMobilePanel';
import QuestionsFiltersMobile from '../../../components/partials/QuestionsFiltersMobile';
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';

export default function QuestionsListPage({ isAssign, isMember }) {

  const [context, dispatch] = useGlobalContext();
  const { userAuth } = context.auth;

  const { filteredQuestions, questionsList, filters, count, scrollY } = context.questions
  let isAdmin = userAuth?.tools.find((t) => t.tool === TOOL_ID).role === "Admin" ? true : false;
  let isOwner = userAuth?.tools.find((t) => t.tool === TOOL_ID).role === "Owner" ? true : false

  const initSortState = {
    title: true,
    code: true,
    author: true,
    date: true,
    attrib: true,
    status: true,
    delay: true,
    'answer.date': true,
    'assignTo.profile.firstName': true,
  }

  const containerRef = useRef(null);
  const scrollRef = useRef(null);
  const [scrollTop, setScrollTop] = useState(0);

  const [sortByReverse, setSortByReverse] = useState(initSortState);
  const [search, setSearch] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [modaleIsOpen, setModaleIsOpen] = useState();
  const [filterIsOpen, setFiltersIsOpen] = useState(false);

  function setFilters(key, value) {
    dispatch({
      type: SET_FILTERS,
      payload: {
        ...filters,
        page: 1,
        [key]: value
      }
    });
  }

  const countFilters = useMemo(() => {
    let count = 0;
    if (filters?.search) {
      count += 1;
    }
    if (filters?.isCompare) {
      count += 1;
    }
    if (filters?.tags?.length > 0) {
      count += filters?.tags.length;
    }
    if (filters?.drugs?.length > 0) {
      count += filters?.drugs.length;
    }
    if (filters?.centers?.length > 0) {
      count += filters?.centers.length;
    }
    if (filters?.types?.length > 0) {
      count += filters?.types.length;
    }
    if (filters?.assignTo?.length > 0) {
      count += filters?.assignTo.length;
    }
    return count;
  }, [filters]);

  const initData = useCallback(() => {
    getNotifsAction(dispatch, "Medocta");
    if (scrollY) {
      containerRef.current.scrollTo({
        top: scrollY,
        left: 0,
      });
    }
    getQuestionListsAction(dispatch);
    dispatch({
      type: GET_QUESTION,
      payload: null
    });
    dispatch({
      type: GET_ANSWER,
      payload: null
    });
  }, [dispatch, scrollY]);

  useEffect(() => {
    initData();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    postQuestionsFilteredAction(dispatch, filters);
    setIsLoading(true);
    // eslint-disable-next-line
  }, [filters.orderBy, filters]);

  useEffect(() => {
    setIsLoading(false);
  }, [filteredQuestions])

  function sortList(type, isReverse) {
    setSortByReverse({ ...initSortState, [type]: isReverse });
    dispatch({
      type: SET_FILTERS,
      payload: {
        ...filters,
        page: 1,
        orderBy: {
          key: type,
          order: isReverse ? 'desc' : 'asc'
        }
      }
    });
  };

  function handleScroll(e) {
    dispatch({
      type: SET_SCROLL_Y,
      payload: e.target.scrollTop
    })
    if (!isLoading && count > filteredQuestions.length && e.target.scrollTop > scrollTop && scrollRef?.current.getBoundingClientRect().bottom <= containerRef?.current.getBoundingClientRect().bottom) {
      setScrollTop(e.target.scrollTop);
      dispatch({
        type: SET_FILTERS,
        payload: {
          ...filters,
          page: filters.page + 1,
        }
      });
    }
  }

  function closeModale() {
    setModaleIsOpen()
    dispatch({
      type: 'EXPORT_ANSWERS',
      payload: null
    });
  }

  return (
    <>
      <FiltersToggle
        handleClick={() => setFiltersIsOpen(true)}
        count={countFilters}
      />
      <FiltersMobilePanel
        close={() => setFiltersIsOpen(false)}
        isOpen={filterIsOpen}
      >
        <QuestionsFiltersMobile />
      </FiltersMobilePanel>
      <div className={`page-container ${styles.container} ${isOwner ? styles.owner : ''}`}>
        {isOwner && <div className={styles['owner-nav']}>
          <NavLink to="/question-assign" activeClassName={styles.active}>
            Mes questions
          </NavLink>
          <NavLink to="/question" activeClassName={styles.active}>
            Toutes les questions
          </NavLink>
        </div>}
        <div className="content">
          <header>
            {isAssign || isMember ?
              <h1>Mes questions en cours</h1>
              :
              <h1>{isAdmin ? "Questions" : "Toutes les questions"}</h1>
            }
            <div className={styles.buttons}>
              {isAdmin &&
                <button
                  onClick={() => setModaleIsOpen("export")}
                  className={styles['btn-create']}>
                  <p>Exporter</p> <FaDownload size={18} />
                </button>
              }
              <Link to="/ask" className={styles['btn-create']}>
                <p>Créer une question</p> <RiQuestionnaireFill size={24} />
              </Link>
            </div>
          </header>
          <div className={styles['header-mobile']}>
            <div className={styles.input}>
              <input type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder='Recherche...'
              />

              <button
                type="button"
                onClick={() => setFilters('search', search)}
                className={search || filters?.search ? styles.valid : ''}
              >
                <IoSearch />
              </button>
            </div>
            <Link to="/ask" className={styles['btn-create']}>
              <img src={plusIcon} alt="Créer une question" />
            </Link>
          </div>
          <div className={`${styles.row} ${styles.sort}`}>
            <SortButton name={"Code"} action={() => sortList('code', !sortByReverse.code)} state={sortByReverse.code} className={`${styles.col}`} />
            <SortButton name={"Titre de la question"} action={() => sortList('title', !sortByReverse.title)} state={sortByReverse.title} className={`${styles.col} ${styles.title}`} />
            <SortButton name={"Auteur"} action={() => sortList('author', !sortByReverse.author)} state={sortByReverse.author} className={`${styles.col} ${styles.author}`} />
            <SortButton name={"Date"} action={() => sortList('date', !sortByReverse.date)} state={sortByReverse.date} className={`${styles.col}`} />
            <SortButton name={"Réponse"} action={() => sortList('answer.date', !sortByReverse['answer.date'])} state={sortByReverse['answer.date']} className={`${styles.col}`} />
            <SortButton name={"Attrib"} action={() => sortList('assignTo.profile.firstName', !sortByReverse['assignTo.profile.firstName'])} state={sortByReverse['assingTo.profile.firstName']} className={`${styles.col}`} />
            <SortButton name={"Statut"} action={() => sortList('status', !sortByReverse.status)} state={sortByReverse.status} className={`${styles.col}`} />
            <SortButton name={"Délais"} action={() => sortList('delay', !sortByReverse.delay)} state={sortByReverse.delay} className={`${styles.col}`} />
          </div>
        </div>
        <div
          ref={containerRef}
          onScroll={(e) => handleScroll(e)}
          className={styles.list}>
          <div className="content" ref={scrollRef}>
            {filteredQuestions && filteredQuestions.filter(q => {
              if (isAssign && q.assignTo?._id !== context.auth.userAuth?._id) return null
              return q
            }).map((question) => <QuestionRow key={question._id} question={question} isMember={isMember} isAssign={isAssign ? true : false} styles={styles} />)}
            {!questionsList && !filteredQuestions && <Loader />}
          </div>
        </div>
      </div>
      <Modale
        isOpen={modaleIsOpen}
        modaleToggle={() => closeModale()}
      >
        {modaleIsOpen === "export" && <ExportAnswersModale closeModale={() => closeModale()} />}
      </Modale>
    </>
  )

}
